<template>
  <div class="page-news" :class="columnMeta.showBreadNav ? '' : 'hide-bread'">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" v-if="columnMeta.showBreadNav" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/intro/`">学院概况</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/intro/base`">基本信息</el-breadcrumb-item>
        <el-breadcrumb-item>{{ columnMeta.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content news-content">
        <column-header2 :data="columnMeta"></column-header2>
        <ic-download v-if="columnMeta.type == 'download'" :data="columnData"></ic-download>
        <ic-mix-news v-else-if="columnMeta.type == 'mix'" :data="columnData"></ic-mix-news>
        <ic-news v-else :data="columnData" :type="columnMeta.type"></ic-news>
        <el-pagination v-if="columnData.length > pageSize" class="g-pagination" :current-page="pageIndex" :page-size="pageSize" layout="prev, pager, next" :total="total" background @current-change="handleIndexChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import News from "_c/News";
import MixNews from "_c/MixNews";
import Download from "_c/Download";
import ColumnHeader from "_c/ColumnHeader2";
import { Loading } from "element-ui";
import { mapState } from "vuex";
export default {
  data() {
    return {
      metaData: {
        environment: {
          name: "学院环境",
          type: "pic",
          tableId: "Environment",
          showBreadNav: false
        },
        news: {
          name: "新闻速递",
          type: "calendar",
          tableId: "CollegeNews",
          showBreadNav: true
        },
        industry: {
          name: "行业/企业资讯",
          tableId: "EnterpriseNews",
          type: "calendar"
        },
        notice: {
          name: "通知中心",
          type: "pic"
        },
        download: {
          name: "资料下载",
          type: "download"
        }
      },
      columnData: [],
      total: 0,
      pageSize: 9,
      pageIndex: 1,
      name: "",
      columnMeta: {}
    };
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  created() {
    this.init();
  },
  components: {
    [News.name]: News,
    [ColumnHeader.name]: ColumnHeader,
    [Download.name]: Download,
    [MixNews.name]: MixNews
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      let params = [
        { Key: "College", Value: this.collegeData.cid, CompareType: "EqualTo" }
      ];
      var queryParams = {
        name: this.columnMeta.tableId,
        index: this.pageIndex,
        size: this.pageSize,
        params: params
      };
      if (this.name === "industry") {
        if (this.collegeData.enterpriseIds) {
          queryParams.params = [
            {
              Key: "Enterprise",
              Value: this.collegeData.enterpriseIds,
              CompareType: "In"
            }
          ];
        } else {
          return;
        }
      }

      getData(queryParams).then(res => {
        this.columnData = (res.Data || []).map(item => {
          item.link =
            this.$subsitePrefix +
            `/column/detail/${this.columnMeta.tableId}?id=${item.Id}`;
          return item;
        });
        this.total = res.TotalCount;
      });
    },
    init() {
      let loadingOptions = {
        target: this.$refs.mainContainer,
        fullscreen: false
      };
      let loadingInstance = Loading.service(loadingOptions);

      let name = this.$route.params.name;
      this.name = name;
      this.columnMeta = this.metaData[name];
      if (this.columnMeta) {
        this.loadData();
      }
      loadingInstance.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-news {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-news,
  ::v-deep .comp-download {
    padding: 5px 0 20px 0;
  }
  ::v-deep .comp-download li {
    padding: 0;
  }
  ::v-deep .comp-news--calendar {
    li {
      border-bottom: 0;
      padding: 0 0 24px 93px;
      height: 70px;
    }
    h3 {
      font-size: 20px;
      line-height: 28px;
      padding: 8px 0 4px 0;
    }
    p {
      font-size: 14px;
      line-height: 18px;
    }
    a {
      .date {
        width: 77px;
        height: 70px;
        top: 0;
        strong {
          margin-top: 12px;
          margin-bottom: 4px;
        }
      }
    }
  }
  .news-content {
    padding-bottom: 40px;
    ::v-deep .comp-column-header {
      padding: 0 0 16px 0;
    }
  }
}
.page-news.hide-bread {
  padding-top: 24px;
}
</style>
